/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useArticle, useMedia } from '@api/hooks';
import { getImage } from '@utils/media';
import { InfoItem } from '@molecules';
import { formatArticleError } from '@utils';

const Item = ({ module, errors }) => {
  const { data: article, error } = useArticle(module.content.articleId);
  const { media } = useMedia(getImage(module.content, 'image'));

  let description = module.content.title;

  if (article) {
    description = error ? formatArticleError(error) : article.title || 'loading article title...';
  }

  return (
    <InfoItem.WithError error={errors} size="large" image={media.src} description={description}>
      Single Page Feature
    </InfoItem.WithError>
  );
};

export default Item;
